module.exports = __webpack_public_path__ + "img/img8.7e5b7c13.svg";